import NavBarWizardBaseCtrl from './NavBarWizardBaseCtrl';

export default function () {
    return {
        restrict: 'A',
        controller: NavBarWizardBaseCtrl
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/wizard/NavBarWizardBaseDirective.js
// module id = 1187
// module chunks = 0